<template>
    <v-card v-if="item" :height="height">
    <!-- <v-row justify="space-between" class="mx-0"><h2>Import contacts</h2><action-button icon="$close" tooltip="Close" @click="close"/></v-row> -->
    <v-card-title><span><slot name="title" /></span><v-spacer /><action-button v-if="dialog" icon="$close" :tooltip="$t('dialog.close')" @click="close"/></v-card-title>
    <v-stepper v-if="isActive"
        id="pfid1618852734" 
        v-model="step"
        vertical
        class="elevation-0"
    >
    <v-stepper-step
      step="1"
      :complete="step > 1"
    >{{$t('form.selectFile')}}</v-stepper-step>
    <v-stepper-content step="1">
      <v-form ref="uform" @submit.prevent="upload()">
      <v-file-input
        id="pfid1618852751" 
        :label="fileLabel"
        :accept="accept"
        :rules="[(v) => !!v || $t('form.rules.required'), value => !value || value.size < 10485760 || $t('form.rules.fileSize', {size: '10 MB'})]"
        show-size
        truncate-length="30"
        v-model="file"
    ></v-file-input>
    
   
      <v-btn
      id="pfid1618852761" 
      type="submit"
        color="primary"
        class="mt-2"
        :disabled="!file"
      >
        <v-icon left>$upload</v-icon>{{$t('dialog.continue')}}
      </v-btn>
      </v-form>
    </v-stepper-content>

    <v-stepper-step 
      step="2"
      :complete="step > 2"
    >{{$t('form.upload')}}</v-stepper-step>

    <v-stepper-content step="2">
      <v-progress-linear v-model="uploadProgress"></v-progress-linear>
    </v-stepper-content>

    <v-stepper-step
      step="3"
      :complete="step > 3"
    >
      {{ $t('imports.segments') }}
    </v-stepper-step>
   
     <v-stepper-content step="3">
      <tag-selector ref="ts" multiple v-model="tags" :domain="item.id" />
      <v-row no-gutters>
      <v-col cols="12" md="6">
      <v-switch class="ml-2" :label="$t('imports.addExisting')" v-model="addExisting" />
      <v-switch class="ml-2" :label="$t('imports.createNotifications')" v-model="createNotifications" />
      </v-col>
      <v-col cols="12" md="6">
      <v-alert class="fill-height" v-if="addExisting && createNotifications" type="warning"  colored-border border="left">
        {{ $t('imports.notificationsWarning') }}
      </v-alert>
      </v-col> 
      </v-row>
       <v-btn
        id="pfid1656849551" 
        color="primary"
        :disabled="error"
        @click="step = 4"
      >{{$t('dialog.continue')}}</v-btn>
    </v-stepper-content>
  
  <v-stepper-step
      step="4"
      :complete="step > 4"
    >
      {{ $t('imports.review') }}
    </v-stepper-step>

    <v-stepper-content step="4">
      <slot name="analysis" v-if="stats" />
      <v-btn
        id="pfid1618852796" 
        color="primary"
        :disabled="error"
        @click="step = 5; createJob()"
      >{{$t('dialog.confirm')}}</v-btn>
      <v-btn id="pfid1618852833" text @click="reset()">{{$t('dialog.back')}}</v-btn>
    </v-stepper-content>
    <v-stepper-step
      step="5"
      :complete="step > 5"
    >{{$t('common.import')}}</v-stepper-step>
    <v-stepper-content step="5">
      <v-progress-linear v-if="job" v-model="job.progress"></v-progress-linear>
      <p class="text-center subtitle-2 mt-2">{{$t('common.wait')}}</p>
    </v-stepper-content>
    <v-stepper-step
      step="6"
      :complete="step > 6"
    >{{$t('common.results')}}</v-stepper-step>
    <v-stepper-content step="6">
          <slot v-if="job && job.data" name="results" :job="job" />
          <v-btn id="pfid1618852847" color="primary" @click="close">{{$t('dialog.close')}}</v-btn>
          <v-btn id="pfid1618852851" text @click="reset()">{{$t('dialog.startOver')}}</v-btn>
    </v-stepper-content>
    </v-stepper>
    <v-card-text v-else >
    <v-alert color="orange" type="warning" border="left" outlined>
      <span v-if="isIncomplete">{{ $t('imports.incomplete') }}</span>
      <span v-else>{{$t('dashboard.inactive')}}</span>
    </v-alert>
    </v-card-text>
    </v-card>
    <v-skeleton-loader type="heading,card@3" v-else />
</template>
<script>

import { mapState, mapGetters } from "vuex";
//import TagSelector from "./TagSelector.vue"
import TagSelector from "./TagAutocomplete.vue"
export default {
    name: 'ImportWizard',
    mixins: [],
    components: { TagSelector },
    props: {
      type: { type: String, required: true },
      error: Boolean,
      fileLabel: String,
      accept: String,
      analysis: Object,
      selectedTags: [Array],
      dialog: { type: Boolean, default: true},
      height: { type: [String, Number] }
    },
    data() {
        return {
            step: 1,
            file: null,
            tags: this.selectedTags ?? [],
            createNotifications: false,
            addExisting: false
        }
    },
    computed: {
        ...mapState('domains', ['item']),
        ...mapGetters('domains', ['isActive', 'isIncomplete']),
        ...mapState('imports', ['job', 'stats', 'uploadProgress']),
    },
    watch: {
      stats() {
        this.$emit('update:analysis', this.stats);
      }
    },
    methods: {
        close() {
          this.reset();
          this.$emit('close');
          this.$store.dispatch('domains/get', { id: this.item.id });
        },
        upload() {
            // start upload
            if(!this.$refs.uform.validate()) {
              return;
            }
            this.step = 2;
            this.$store.dispatch('imports/uploadFile', { domain: this.item.id, type: this.type, file: this.file }).then(() => { this.step = 3 });
        },
        reset() {
            this.step = 1;
            this.file = null;
            this.$refs.ts?.reset();
            this.$store.dispatch('imports/reset');
        },
        createJob() {
            this.$store.dispatch('imports/createJob', { domain: this.item.id, tags: this.tags, config: { createNotifications: this.createNotifications, addExisting: this.addExisting} }).then(() => { setTimeout(this.checkJob, 5000); });
            // start timer - check job
        },
        checkJob() {
            console.debug('Checking job...');
            this.$store.dispatch('imports/updateJob').then((job) => {
                if( job.result == 'COMPLETED') {
                    this.step+=1;
                } else {
                    setTimeout(this.checkJob, 1000);
                }
            });
        }
    }
}
</script>
